export default __webpack_public_path__ + "static/media/great-ocean-image.f6b862a9.jpg";